export function realTimeStepIcon(step) {
  if (!step?.is_real_time) return ''

  return require('assets/images/rss-green.svg')
}

export function routeRealTimeIcon(route) {
  if (!route?.steps?.some(step => step?.is_real_time)) return ''

  return require('assets/images/rss-green.svg')
}
